import { create } from 'zustand';
import {
  getProjects,
  getSubmissions,
  Project,
  Submission,
} from '@/services/PagesServices/GroupProjectManagementService';

interface GroupProjectManagementState {
  projects: Project[] | null;
  submissions: Submission[] | null;
  loading: boolean;
  error: string | null;

  fetchProjects: () => Promise<void>;
  fetchSubmissions: () => Promise<void>;
}

const useGroupProjectManagementStore = create<GroupProjectManagementState>((set, get) => ({
  projects: null,
  submissions: null,
  loading: false,
  error: null,

  fetchProjects: async () => {
    try {
      set({ loading: true, error: null });
      const response = await getProjects();
      set({ projects: response.data || [], loading: false });
    } catch (error: any) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  fetchSubmissions: async () => {
    try {
      set({ loading: true, error: null });
      const response = await getSubmissions();
      set({ submissions: response.data || [], loading: false });
    } catch (error: any) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },
}));

export default useGroupProjectManagementStore;
